export default __webpack_public_path__ + "static/media/homedialysis02.8a09b23e.png";